import React, { Component } from 'react';
import './PersonRegist.css'
import Api from '../../api/api';
import intl from 'react-intl-universal';
import Select from 'react-select';
import config from './config'



//展示结果
export default class QuestionList extends Component {
  constructor(props) {
    super();
    this.state = {                          
       
     
    };
  
  }
  
  componentDidMount(){
    document.title = '结果'

  }
  render() {
   
    let type=this.getQueryString('type')
    let flag=this.getQueryString('flag')
    
         
    
    return (
      <div  className='flex-column-container' style={{paddingLeft:12,paddingRight:12,flex:1, alignItems:'center',paddingTop:'30%'}}>
           
           <img  style={{width:'90px',marginBottom:'10px'}}  src={require('../../assets/success.png')} alt="" />
           <p>  {flag? (type==global.constants.Suggestion||type==global.constants.faultpost)?'提交成功':'认证成功':'失败'}</p>

           <button className="pr-button" onClick={this.back}>{'返回'}</button> 
         </div>

     
    )
  }


  back=()=>{
    let type=this.getQueryString('type')
      if(type==global.constants.regist){
        this.props.history.push('/person/PersonCenter')
      }else{
        this.props.history.goBack()
      }
      
  }

  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return null;
  }

  
}



// WEBPACK FOOTER //
// ./src/views/person/ShowResult.js